module.exports = __webpack_public_path__ + "52fefcf18e8d1fa31033984befa94aca.png";